export const typeOptions = [
  { label: "Usuários", value: "users" },
  { label: "Anúncios", value: "announcements" },
  { label: "Tribos", value: "tribos" },
];

export const intervalOptions = [
  { label: "Dia", value: "day" },
  { label: "Mês", value: "month" },
  { label: "Semana", value: "week" },
];

export const intervalLabels = [
  {
    id: 0,
    name: "Dia",
  },
  {
    id: 1,
    name: "Mês",
  },
  {
    id: 2,
    name: "Semana",
  },
];

export const typeLabels = [
  {
    id: 0,
    name: "Feed",
  },
  {
    id: 1,
    name: "Venda Cacique",
  },
  {
    id: 2,
    name: "Venda Tribo Master",
  },
];
